import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M5.704 16.815c.818 0 1.481.663 1.481 1.481v2.223c0 .818-.663 1.481-1.481 1.481H3.48A1.481 1.481 0 0 1 2 20.519v-2.223c0-.818.663-1.481 1.481-1.481h2.223zm15.555 2.469a.74.74 0 0 1 0 1.481H8.914a.74.74 0 1 1 0-1.481zm-15.555-.988H3.48v2.223h2.223v-2.223zm0-8.889c.818 0 1.481.664 1.481 1.482v2.222c0 .818-.663 1.482-1.481 1.482H3.48A1.481 1.481 0 0 1 2 13.11V10.89c0-.818.663-1.482 1.481-1.482h2.223zm15.555 2.47a.74.74 0 0 1 0 1.481H8.914a.74.74 0 1 1 0-1.481zm-15.555-.988H3.48v2.222h2.223V10.89zm0-8.889c.818 0 1.481.663 1.481 1.481v2.223c0 .818-.663 1.481-1.481 1.481H3.48A1.481 1.481 0 0 1 2 5.704V3.48C2 2.663 2.663 2 3.481 2h2.223zm15.555 2.47a.74.74 0 0 1 0 1.48H8.914a.74.74 0 1 1 0-1.48zM5.704 3.48H3.48v2.223h2.223V3.48z' />
  </svg>
);
